const TableCellPercentage = ({ value }) => {
  let percentage = "";
  if (value) percentage = Math.round(value * 1000) / 10;
  return <div className="table-cell-percentage">{percentage} %</div>;
};

export default TableCellPercentage;
